
import { ref, computed, watch, onMounted } from "vue";
import { useStore } from "vuex";
import useBreakpoints from "@/services/Breakpoints";

export default {
  setup() {
    const store = useStore();
    const promotionalVideoExists = ref(false);
    const { type } = useBreakpoints();
    const linkVideo = ref("");
    const hideVideo = ref(false);
    const eventData = computed(() => {
      return store.getters["user/eventData"];
    });
    function showVideo() {
      if (eventData.value) {
        linkVideo.value = eventData.value.promotionalVideo;
        if (linkVideo.value && linkVideo.value !== "") {
          promotionalVideoExists.value = true;
        } else {
          promotionalVideoExists.value = false;
        }
      } else promotionalVideoExists.value = false;
    }
    
    onMounted(() => {
      if (eventData.value) showVideo();
    });
    watch(eventData, () => {
      if (eventData.value) showVideo();
    });
    return {
      promotionalVideoExists,
      linkVideo,
      hideVideo,
      type,
    };
  },
};
